import { mutator } from 'satcheljs';
import { upsertItemsForDescriptor } from '../actions/internalActions';
import { getStore } from '../store/store';
import { hasDescriptor } from '../query/hasDescriptor';
import { getCachedFunctions } from '../store/CachedFunctions';

export const upsertItemsForDescriptorMutator = mutator(upsertItemsForDescriptor, actionMessage => {
    const { key, descriptor } = actionMessage;
    const store = getStore(key);
    const { containsDescriptor } = getCachedFunctions(key);

    if (!hasDescriptor(store, descriptor, containsDescriptor)) {
        getStore(key).descriptors.set(descriptor.Id, descriptor);
    }
});
